import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  list: {
    service_patient_objects: [],
  } as any,
  detail: {} as any,
};

const serviceObjectSlice = createSlice({
  name: 'serviceObject',
  initialState,
  reducers: {
    createServiceObject: (_state, _action: PayloadAction<{ data: any }>) => undefined,
    requestServicesObject: (_state, _action) => undefined,
    saveServicesObject: (state, action: PayloadAction<{ list: any }>) => {
      const { list } = action.payload;
      state.list = list;
    },
    requestServiceObject: (_state, _action: PayloadAction<{ id: any }>) => undefined,
    saveServiceObject: (state, action: PayloadAction<{ data: any }>) => {
      state.detail = action.payload.data;
    },
    updateServiceObject: (_state, _action: PayloadAction<{ data: any }>) => undefined,
    deleteServiceObject: (_state, _action: PayloadAction<{ id: any }>) => undefined,

    resetServiceObject: () => initialState,
  },
});

export default serviceObjectSlice;
